import { render, staticRenderFns } from "@/client/budget/views/acceptance/start/start.pug?vue&type=template&id=86820f28&scoped=true&lang=pug&external"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "@/client/budget/views/acceptance/start/start.scss?vue&type=style&index=0&id=86820f28&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86820f28",
  null
  
)

export default component.exports